import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

const reportName = "Despachos por quantidade de apoio"
const reportId = "support-amount"
const SupportAmount = ({data}) => {

  useEffect(() => {
    const statusData = GraphicUtils.horizontalStackedBarChart(data, reportId, "support");

    if (statusData) {
      const tableRows = statusData.labels.map((label, i) => [label, statusData.values[i]]);
      ReportUtils.createExportableTable(["Descrição", "Quantidade"], tableRows, "Despachos com apoio");
    }

  }, [data]);

  return (
    <>
      <div className="chart-report relative">
        <span className="chart-title">{reportName}</span>
        { data.length > 0 &&
          <span className="text-[14px] right-[32px] leading-[20px] absolute font-bold">Total: {data.reduce((acc, el) => acc + el.qty, 0)}</span>
        }
        <div className="mt-1 flex gap-[3px] w-full" id={reportId}></div>
      </div>

      <div className="chart-divisor"></div>
    </>
  );
};
export default SupportAmount;